<template>

    <el-form @submit.native.prevent="submitForm('form')" :model="form" :rules="rules" ref="form" label-width="120px" label-position="left" :show-message="false">
    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">게시물 인증</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body">
        <p class="mb-3 text-center text-primary2">게시물 등록시 입력하신 비밀번호를 입력하세요.</p>
        <el-form-item class="mb-0"  label="비밀번호" prop="password" >
            <el-input autofocus type="password" v-model="form.password"></el-input>
        </el-form-item>


      </div>
      <div class="modal-footer">
        <el-form-item>
            <el-button type="primary" native-type="submit" icon="el-icon-check">확인</el-button>
            <el-button @click="$emit('dismiss')">닫 기</el-button>
        </el-form-item>


      </div>
    </div>
    </el-form>

</template>

<script>


export default {
    props: {
        handler: {
            type: Function
        },
    },
    mounted() {
      setTimeout(()=> $('input[type=password]').focus(),700)
    },
    data() {
      return {
        form: {
          password: '',
        },
        rules: {
          password: [
            { required: true, message: ' ', trigger: 'change' },
            { required: true, message: ' ', trigger: 'blur' },
          ],
        }
      };
    },    
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$emit('close', this.form.password);
                this.handler( this.form.password )
            } else {
                alert('비밀번호를 입력해 주세요')
                return false;
            }
            });
        },
    },

}
</script>